<div class="mct-flex mct-col mct-gap-16">
  <div class="mct-flex mct-row mct-justify-between mct-items-center mb-3">
    <div class="mct-flex mct-row mct-gap-15">
      <h3 class="m-0">
        {{ 'events.attendees.management.tab-title' | translate | titlecase }}
        <span
          ><a href="https://support.weblinkinternational.com/hc/en-us/articles/115002223347" target="_blank" class="ml-2">
            <i class="pi pi-question-circle wc-help-icon" [title]="'events.attendees.management.tab-title-help' | translate"></i> </a
        ></span>
        <span class="wl-event-attendee-refresh-link">
          <a href="#" (click)="$event.preventDefault(); resetAndSearch()">
            {{ 'common.refresh' | translate | titlecase }}
          </a>
        </span>
      </h3>
    </div>
    <div class="text-right text-muted">
      <span class="font-weight-bold text-dark">{{ unfilteredAttendeeSearchResult.TotalCount }}</span>
      {{ 'events.attendees.management.total-count-label' | translate | titlecase }}
      <span class="ml-2">
        (<a href="#" (click)="$event.preventDefault(); handleAttendeesWithNoProfileIdClick()" class="text-danger">
          {{ unfilteredAttendeeSearchResult.AttendeesWithoutProfileCount }}
          {{ 'events.attendees.management.total-without-profileid-count-label' | translate }} </a
        >)
      </span>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-sm-6">
      <div class="input-group">
        <span class="input-group-addon"><i class="pi pi-search"></i></span>
        <input
          type="text"
          class="form-control"
          wl-on-enter-press
          (onEnterPess)="search()"
          [(ngModel)]="searchParams.Keyword"
          [placeholder]="'common.search' | translate"
        />
        <span class="input-group-btn">
          <button pButton type="button" class="atlas-btn atlas-btn-primary tall ml-2" (click)="startSearch()" [disabled]="isSearching">
            <i *ngIf="!isSearching" class="pi pi-search"></i>
            <wl-busy *ngIf="isSearching" [show]="isSearching"></wl-busy>
          </button>
          <button pButton type="button" class="atlas-btn atlas-btn-primary tall ml-2" (click)="resetAndSearch()" [disabled]="isSearching">
            <i class="pi pi-times-circle"></i>
          </button>
        </span>
      </div>
    </div>

    <div class="col-sm-6">
      <p-select
        [options]="sortByFields"
        [(ngModel)]="searchParams.OrderBy"
        (onChange)="getAttendees()"
        optionLabel="name"
        optionValue="value"
        class="w-100"
        [placeholder]="'common.sort-by' | translate | titlecase"
      >
      </p-select>
    </div>
  </div>

  <div class="mb-3">
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary p-button-text p-button-sm"
      (click)="toggleAdvancedSearch()"
      [icon]="showAdvancedSearch ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
      [label]="'common.advancedSearch' | translate | titlecase"
    ></button>
  </div>

  @if (showAdvancedSearch) {
    <div class="mb-4 bg-light border mct-flex mct-col mct-gap-12 mct-justify-center mct-items-start">
      <div class="mb-3 mct-flex mct-col mct-gap-3 mct-justify-center mct-items-start">
        <div>
          <label class="font-weight-bold d-block">{{ 'events.registration.management.sign-up-date-label' | translate | titlecase }}</label>
        </div>
        <div class="mct-flex mct-row mct-justify-center mct-items-start mct-gap-12 w-100">
          <wl-date-selector [(ngModel)]="searchParams.SignUpStartDate" [disabled]="searchParams.SearchAnySignUpDate"></wl-date-selector>
          <div><span class="text-muted">—</span></div>
          <wl-date-selector [(ngModel)]="searchParams.SignUpEndDate" [disabled]="searchParams.SearchAnySignUpDate"></wl-date-selector>
        </div>
        <div class="mt-5">
          <p-checkbox
            binary="true"
            [(ngModel)]="searchParams.SearchAnySignUpDate"
            name="searchAnySignUpDate"
            id="searchAnySignUpDateCheckbox"
          ></p-checkbox>
          <label for="searchAnySignUpDateCheckbox" class="ml-2">{{
            'events.registration.management.search-any-date-label' | translate
          }}</label>
        </div>
      </div>

      <div class="mb-3 mct-flex mct-col w-100 mct-gap-3 mct-justify-center mct-items-start">
        <div class="mb-3 w-100 mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-gap-15 mct-justify-start mct-items-start">
          <div class="border-right">
            <label class="font-weight-bold">{{
              'events.registration.management.advanced-common-criteria-label' | translate | titlecase
            }}</label>
            <div class="mt-2">
              <div class="mb-2">
                <p-checkbox binary="true" [(ngModel)]="searchParams.AllUnpaid" name="allUnpaid" id="allUnpaidCheckbox"></p-checkbox>
                <label for="allUnpaidCheckbox" class="ml-2">{{ 'events.registration.management.show-all-unpaid-label' | translate }}</label>
              </div>
              <div class="mb-2">
                <p-checkbox
                  binary="true"
                  [(ngModel)]="searchParams.AllWithProfileIdNotAssigned"
                  name="allWithProfileIdNotAssigned"
                  id="allWithProfileIdNotAssignedCheckbox"
                ></p-checkbox>
                <label for="allWithProfileIdNotAssignedCheckbox" class="ml-2">{{
                  'events.registration.management.show-all-with-no-profile-id-assigned-label' | translate
                }}</label>
              </div>
              <div class="mb-3">
                <p-checkbox binary="true" [(ngModel)]="searchParams.AllAttended" name="allAttended" id="allAttendedCheckbox"></p-checkbox>
                <label for="allAttendedCheckbox" class="ml-2">{{
                  'events.registration.management.show-all-attended-label' | translate
                }}</label>
              </div>
            </div>
          </div>

          <div>
            <label class="font-weight-bold">{{ 'events.registration.management.event-items-label' | translate | titlecase }}</label>
            <div class="event-items-container border rounded p-2 bg-white mt-2">
              @for (eventItem of eventItems; track eventItem.ItemNum) {
                <div class="mb-1">
                  <p-checkbox
                    binary="true"
                    [(ngModel)]="eventItem.Selected"
                    [name]="'eventItem' + eventItem.ItemNum"
                    [id]="'eventItem' + eventItem.ItemNum"
                  ></p-checkbox>
                  <label [for]="'eventItem' + eventItem.ItemNum" class="ml-2">{{ eventItem.Descr }}</label>
                </div>
              }
            </div>
          </div>
        </div>
        <div>
          <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="search()" [disabled]="isSearching">
            <i [class]="isSearching ? 'pi pi-spin pi-spinner' : 'pi pi-search'" class="mr-2"></i>
            {{ (isSearching ? 'common.searching' : 'common.search') | translate | titlecase }}
          </button>
        </div>
      </div>
    </div>
  }

  <div class="p-3 mb-4 border-primary shadow-sm bg-white">
    <div class="mct-flex mct-row mct-justify-center mct-items-start mct-gap-10 flex-wrap">
      <div style="flex-grow: 1; min-width: 250px">
        <p-select
          [options]="actions"
          [(ngModel)]="selectedAction"
          (onChange)="actionChanged($event.value)"
          optionLabel="name"
          optionValue="value"
          class="w-100"
          name="actionSelection"
          id="actionSelection"
          [placeholder]="'common.action' | translate | titlecase"
        >
        </p-select>
      </div>
      <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="executeAction()" [disabled]="executing">
        <i [class]="executing ? 'pi pi-spin pi-spinner': 'pi pi-play'" class="mr-2"></i>
        {{ 'common.execute' | translate | titlecase }}
      </button>
      <i class="pi pi-question-circle text-muted" [title]="'events.attendees.management.actions-help' | translate"></i>
    </div>

    @if (selectedAction == 9) {
      <div class="mt-15 row">
        <div class="col-sm-3 text-right-sm align-middle pt-1">
          {{ 'events.attendees.management.table-name-label' | translate | titlecase }}
        </div>
        <div class="col-sm-6">
          <input class="form-control" [(ngModel)]="tableName" />
        </div>
      </div>
    }

    @if (selectedAction == 11) {
      <div class="mt-15 row mct-gap-10">
        <div class="col-sm-12 grid-custom-inputs" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px">
          <div class="input-group">
            <span class="input-group-addon small">{{ 'events.attendees.management.custom2-label' | translate }}</span>
            <input class="form-control" [(ngModel)]="custom2" />
          </div>
          <div class="input-group">
            <span class="input-group-addon small">{{ 'events.attendees.management.custom3-label' | translate }}</span>
            <input class="form-control" [(ngModel)]="custom3" />
          </div>
          <div class="input-group">
            <span class="input-group-addon small">{{ 'events.attendees.management.custom4-label' | translate }}</span>
            <input class="form-control" [(ngModel)]="custom4" />
          </div>
          <div class="input-group">
            <span class="input-group-addon small">{{ 'events.attendees.management.custom5-label' | translate }}</span>
            <input class="form-control" [(ngModel)]="custom5" />
          </div>
        </div>
      </div>
    }

    @if (selectedAction == 5) {
      <div class="mt-15">
        <wl-affcode-mass-add #massAddAffCode [showButtons]="false"></wl-affcode-mass-add>
      </div>
    }
  </div>

  <div class="position-relative">
    <p-table [showGridlines]="true"
      #attendeeDataGrid
      [value]="attendeeSearchResult.Result"
      [paginator]="true"
      [rows]="pageSize"
      [lazy]="true"
      [loading]="isSearching"
      (onLazyLoad)="lazyLoadAttendees($event)"
      [totalRecords]="attendeeSearchResult.TotalCount"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="text-center" style="width: 50px">
            <p-checkbox binary="true" (onChange)="selectAll($event)"></p-checkbox>
          </th>
          <th class="text-center" style="width: 60px"></th>
          <th pSortableColumn="ProfileId" style="width: 110px">ID <p-sortIcon field="ProfileId"></p-sortIcon></th>
          <th pSortableColumn="FirstName">
            {{ 'common.personal-information.first-name' | translate | titlecase }} <p-sortIcon field="FirstName"></p-sortIcon>
          </th>
          <th pSortableColumn="LastName">
            {{ 'common.personal-information.last-name' | translate | titlecase }} <p-sortIcon field="LastName"></p-sortIcon>
          </th>
          <th pSortableColumn="RegistrationOrgName" class="hidden-xs">
            {{ 'events.attendees.management.registration-org-column-header' | translate | titlecase }}
            <p-sortIcon field="RegistrationOrgName"></p-sortIcon>
          </th>
          <th class="hidden-xs hidden-sm">
            {{ 'events.attendees.management.items-column-label' | translate | titlecase }}
          </th>
          <th pSortableColumn="Attended" class="text-center" style="width: 100px">
            {{ 'events.attendees.management.attended-column-label' | translate | titlecase }} <p-sortIcon field="Attended"></p-sortIcon>
          </th>
          <th pSortableColumn="AmountDue" class="text-center" style="width: 80px">
            {{ 'common.revenue.paid' | translate | titlecase }} <p-sortIcon field="AmountDue"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-attendee>
        <tr>
          <td class="text-center">
            <p-checkbox binary="true" [(ngModel)]="attendee.Selected" (onChange)="selectOrUnselectAttendee(attendee)"></p-checkbox>
          </td>
          <td class="text-center">
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              [text]="true"
              severity="info"
              (click)="editAttendee(attendee)"
              [disabled]="isSearching"
            ></p-button>
          </td>
          <td>{{ attendee.ProfileId }}</td>
          <td>{{ attendee.FName }}</td>
          <td>{{ attendee.LName }}</td>
          <td class="hidden-xs">{{ attendee.RegistrationOrgName }}</td>
          <td class="hidden-xs hidden-sm small">{{ attendee.ItemsDisplay }}</td>
          <td class="text-center">
            <div *ngIf="!attendee._updatingAttendedFlag">
              <p-checkbox binary="true" [(ngModel)]="attendee.Attended" (onChange)="handleAttendeeAttendedCheckChanged(attendee)">
              </p-checkbox>
            </div>
            <wl-busy [show]="attendee._updatingAttendedFlag"></wl-busy>
          </td>
          <td class="text-center">
            <i
              class="pi"
              [ngClass]="attendee.AmountDue <= 0 ? 'pi-check-circle text-success' : 'pi-circle text-muted'"
              style="font-size: 1.5rem"
            ></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="mt-3 mct-flex mct-row mct-gap-10">
    <p-select
      name="pageSizeSelection"
      id="pageSizeSelectionId"
      [options]="pageSizeOptions"
      [(ngModel)]="pageSizeSelection"
      (onChange)="handleAttendeeGridPageSizeChange($event.value)"
      optionLabel="name"
      optionValue="value"
      placeholder="{{ 'common.page-size.show-20' | translate | titlecase }}"
    >
    </p-select>
    <i class="pi pi-question-circle text-muted" [title]="'events.attendees.management.page-size-help' | translate"></i>
  </div>
</div>

<p-dialog
  #selectEventItemsModal
  [(visible)]="showModal"
  modal="true"
  [closable]="true"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">{{ 'events.attendees.management.event-item-modal-title' | translate | titlecase }}</h4>
  </ng-template>

  <div class="p-2">
    <div class="list-group border rounded shadow-sm" style="max-height: 300px; overflow-y: auto">
      <div *ngFor="let eventItem of eventItems" class="list-group-item">
        <p-checkbox binary="true" [(ngModel)]="eventItem.Selected" [inputId]="'modalEventItem' + eventItem.EventItemId"></p-checkbox>
        <label [for]="'modalEventItem' + eventItem.EventItemId" class="ml-2">{{ eventItem.Descr }}</label>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-gap-10">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="flagOrUnflagAttendeesForSelectedEventItems()"
        icon="pi pi-bolt"
        [label]="'common.execute' | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="cancelSelectedEventItems()"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
<app-back-to-top [centered]="true"></app-back-to-top>
